var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding-box-normal"},[_c('b-dropdown',{attrs:{"text":"SELECCIONA TU COLEGIO!"}},_vm._l((_vm.userSchools),function(school,index){return _c('b-dropdown-item',{key:index,on:{"reload-grades":_vm.reloadData,"click":function($event){return _vm.changeSchoolID(school.id)}}},[_vm._v(" "+_vm._s(school.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }